import Fetch from "utils/fetch";

export const getCancellationJustifications = () => (
  Fetch.get("orders:cancellation-justifications").then(({ data }) => data)
);